import Hero from "@/components/Hero";
import FinancingStrip from "@/components/financing/FinancingStrip";
import Portfolio from "@/components/Portfolio";
import Team from "@/components/Team";
import Services from "@/components/Services";
import OneTeam from "@/components/OneTeam";
import Credibility from "@/components/Credibility";
import Capabilities from "@/components/Capabilities";
import CtaStrip from "@/components/CtaStrip";
import Manifesto from "@/components/Manifesto";
import Marquee from "@/components/Marquee";
import ServiceArea from "@/components/ServiceArea";
import Contact from "@/components/Contact";
import { useScrollToTarget } from "@/hooks/useScrollToTarget";

export default function Home() {
  useScrollToTarget();
  return (
    <>
      <Hero />
      <FinancingStrip />
      <Portfolio />
      <Team />
      <Services />
      <OneTeam />
      <Credibility />
      <Capabilities />
      <CtaStrip id="2" />
      <Manifesto />
      <Marquee />
      <ServiceArea />
      <Contact />
    </>
  );
}
